/**
 * 背景画像関連のユーティリティ
 */

/**
 * 配列からランダムに要素を選択
 */
function getRandom<T>(array: T[]): T {
  return array[Math.floor(Math.random() * array.length)];
}

/**
 * 時間帯に応じた背景画像のパスを返す
 * @returns 背景画像のパス
 */
export function getBackgroundByTime(): string {
  const now = new Date();
  const hour = now.getHours();
  
  // 時間帯に応じて背景を選択
  if (hour >= 5 && hour < 8) {
    return '/assets/bg/soraroom_morning.jpg'; // 朝（5時-8時）
  } else if (hour >= 8 && hour < 16) {
    // 昼はベンチか教室をランダム表示
    const dayBgs = [
      '/assets/bg/bench_day.jpg',
      '/assets/bg/classroom_day.jpg'
    ];
    return getRandom(dayBgs);
  } else if (hour >= 16 && hour < 19) {
    // 夕方は教室か図書館をランダム表示
    const eveningBgs = [
      '/assets/bg/classroom_evening.jpg',
      '/assets/bg/library_evening.jpg'
    ];
    return getRandom(eveningBgs);
  } else {
    return '/assets/bg/soraroom_night.jpg'; // 夜（19時-5時）
  }
}

export default {
  getBackgroundByTime
};